import { useContext, useState } from 'react'
import { FiLogOut } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AppSpan, AppText, Circle, CustomContainer, FlexColumn, FlexRow, GridContainer, SideBarContainer, SideBarShadow } from "src/style"
import { sideBarData } from './sidebar-data'
import { SidebarMenu } from './sidebar-menu'
import Logo from 'src/assets/svg/logo.svg'
import ProfilePics from 'src/assets/svg/profile-pics.svg'
import SettingsIcon from 'src/assets/svg/settings-icon'
import LogoutIcon from 'src/assets/svg/logout-icon'
// import { DecisionBox } from 'src/component'


export const Sidebar: React.FC = () => {
    const navigate = useNavigate()
    const {info: {userType, organization, userData}, logout} = useContext(AppInfoContext)
    const {visibility, showSideBar, decisionBox} = useContext(VisibilityContext)
    const [isHover, setIsHover] = useState({settings: false, logout: false})
    const [isMobile] = useState(window.matchMedia('(max-width: 770px)').matches)

    async function handleLogout () {
        await logout()
        navigate('/login')
    }

    async function handleLogoutClick () {
        closeSideBarOnMobile()

        decisionBox.show(
            'Are you sue you want to logout?',
            handleLogout,
            null,
            'negative',
            'Yes, Logout'
        )
    }

    function handleSettings () {
        closeSideBarOnMobile()

        navigate('/dashboard/settings')
    }

    function closeSideBarOnMobile () {
        if (isMobile) {
            showSideBar(false)
        }
    }

    return (
        <>
            <SideBarShadow 
                isSideBar={visibility.isSideBar} 
                onClick={() => showSideBar(false)}
            />
            <SideBarContainer 
                isSideBar={visibility.isSideBar}
            >
                <FlexColumn 
                    minHeight='100' 
                    mnHUnit='%' 
                    justifyContent='space-between'
                    className='y-scrollable-container' 
                >
                    <CustomContainer>
                        <FlexRow gap='1'>
                            <GridContainer 
                                width='3.7' 
                                height='3.7' 
                                radius='0.4' 
                                bgColor='#333333'
                            >
                                <img src={Logo} className='img-child'/>
                            </GridContainer>
                            <AppSpan
                                textSize='1.6'
                                color='#ffffff'
                                fontWeight='700'
                            >
                                {organization?.name || 'Humexid'}
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            bottomMargin='3' 
                            topMargin='8'
                        >
                            {
                                sideBarData.map((menu, index) => {
                                    return (
                                        (userType === menu.type || menu.type === 'ALL') && <SidebarMenu item={menu} key={index} />
                                    )
                                })
                            }
                        </CustomContainer>
                    </CustomContainer>
                    
                    <CustomContainer>
                        <GridContainer bottomMargin='0.5'>
                            <Circle
                                size='4.8' 
                                overflow='hidden'
                                bottomMargin='0.5'
                            >
                                <img src={ProfilePics} className='img-child'/>
                            </Circle>
                        </GridContainer>
                        <AppText 
                            color='#ffffff' 
                            fontWeight='700'
                            align='center'
                        >
                            Ridwan Kolawole
                        </AppText>
                        <AppText 
                            color='#BDBDBD' 
                            align='center'
                        >
                            {userData?.email}
                        </AppText>
                        <FlexRow 
                            justifyContent='center'
                            topMargin='1' 
                            gap='1.5'
                        >
                            <SettingsIcon 
                                className='icon-component'
                                isHover={isHover.settings} 
                                onMouseEnter={() => setIsHover({...isHover, settings: true})}
                                onMouseLeave={() => setIsHover({...isHover, settings: false})}
                                onClick={handleSettings}
                            />
                            <LogoutIcon 
                                className='icon-component' 
                                isHover={isHover.logout} 
                                onMouseEnter={() => setIsHover({...isHover, logout: true})}
                                onMouseLeave={() => setIsHover({...isHover, logout: false})}
                                onClick={handleLogoutClick}
                            />
                        </FlexRow>
                    </CustomContainer>
                </FlexColumn>
            </SideBarContainer>
        </>
    )
}